import { render, staticRenderFns } from "./locationDetails.vue?vue&type=template&id=2b619a76"
import script from "./locationDetails.vue?vue&type=script&lang=js"
export * from "./locationDetails.vue?vue&type=script&lang=js"
import style0 from "./locationDetails.vue?vue&type=style&index=0&id=2b619a76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports